export enum UploadWidgetItemStatus {
  Initiated = 'INITIATED',
  Uploading = 'UPLOADING',
  Completed = 'COMPLETED',
  PartiallyCompleted = 'PARTIALLY_COMPLETED',
  Failed = 'FAILED',
  Error = 'ERROR',
}

export enum UploadWidgetItemSection {
  Games = 'GAMES',
  GamesStrategies = 'GAME_STRATEGIES',
  FreeBetLevels = 'FREE_BET_LEVELS',
  Assets = 'ASSETS',
}
